export default __webpack_public_path__ + "static/media/signo_wise.80baf680.mp4";